module.exports = __webpack_public_path__ + "img/01d.00365d2f.svg";